import { userGroup } from "./user-group";

/**
 * JSDoc imports.
 *
 * @import { VariableReferenceScope } from '@app/types';
 */

const keys = {
    // App types
    COLLABORATION: "collab",
    MAIN_BRANCH: "main",
    BRANCH: "branch",
    // Namespaces for use with Cache
    NAMESPACE_DATATRANSFER: "::data-transfer",
    NAMESPACE_DIAGRAM_WIDGET: "::diagram-widget",
    // Debug options
    DEBUG_FORM: "form-component",
    DEBUG_TREE: "tree-view",
    DEBUG_STORAGE: "storage",
    DEBUG_CACHE: "cache",
    DEBUG_UI: "ui",
    // validatio error
    VALIDATION_ERROR: "validationError",
    // Variable scopes
    /** @deprecated Use @see VariableReferenceScope.application */
    SCOPE_APPLICATION: "app",
    /** @deprecated Use @see VariableReferenceScope.conversation */
    SCOPE_CONVERSATION: "conv",
    /** @deprecated Use @see VariableReferenceScope.module */
    SCOPE_MODULE: "mod",
    SCOPE_OUTPUT: "out",
    //variables in script
    GET_APPLICATION_VARIABLES: "api.session().get",
    SET_APPLICATION_VARIABLES: "api.session().set",
    // Permission groups
    USER_GROUP: userGroup,
    // NON_COLLAB: false, this has been moved to Utility which allows use in non-browser environments
    SUPPORT_FLOW_VERSIONS: false,
    CUSTOM_ID_EXPORT: "customex"
};

export class Constant {
    /**
     * Storage for enum-like values, treated as constant values
     * @module Constant
     */
    static get k() {
        return keys;
    }
}
